/**
 * Check if development tools are available.
 * Development tools (like role override) are only available on dev.taktile.com and its subdomains.
 *
 * @returns true if current hostname ends with "dev.taktile.com"
 */
export const isDevToolsAvailable = (): boolean => {
  return window.location.hostname.endsWith("dev.taktile.com");
};
